export default "__VITE_ASSET__Be9MjBXK__"